import {
  SET_APP_PARAMS,
  SET_OS
} from '../mutation-types'

const state = {
  os: null,
  app_version: null,
  model: null,
  network: null,
  os_version: null,
  app_id: null
}

const mutations = {
  [SET_APP_PARAMS] (state, data) {
    state.os = data.os
    state.app_version = data.app_version
    state.model = data.model
    state.network = data.network
    state.os_version = data.os_version
    state.app_id = data.app_id
  },
  [SET_OS] (state, os) {
    state.os = os
  }
}

const actions = {
  setAppParams ({ commit }, data) {
    commit('SET_APP_PARAMS', data)
  },
  setOS ({ commit }, os) {
    commit('SET_OS', os)
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/duduApp.js